import { Routes, Route } from "react-router-dom";
import Login from "./pages/Auth/Login";
import PrivateRoute from "./routes/PrivateRoute";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import SignUp from "./pages/Auth/SignUp";
import { useAuth } from "./hooks/useAuth";
import { useEffect } from "react";
import CropsList from "./pages/crops/CropsList";
import CropDetails from "./pages/crops/CropDetails";
import MainLayout from "./layout/main-layout";
import Dashboard from "./pages/dashboard/Dashboard";
import FarmOverview from "./pages/farm_overview/FarmOverview";

function App() {
  const { isAuthenticated, fetchCurrentUser } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      fetchCurrentUser();
    }
  }, [isAuthenticated]);
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/farm" element={<FarmOverview />} />
        <Route path="crops" element={<CropsList />} />
        <Route path="crops/:id" element={<CropDetails />} />
      </Route>
      <Route path="*" element={<Login />} />
    </Routes>
  );
}

export default App;
